if (process.env.NODE_ENV === 'production') {
  module.exports = require('./responsive.production.js');
} else {
  module.exports = require('./responsive.development.js');
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ux/responsive/dist/es/responsive.js
// module id = 117
// module chunks = 0